import { Button, Table } from "react-bootstrap";
import ExportAnnualPDF from "../../utility/ExportAnnualPdf";
import { useState, useEffect } from "react";
import API_BASE_URL from "../../config";
import { authFetch } from "../../utility/AuthFetch";

function Annual({
  student,
  standardLabel,
  divisionLabel,
  marksData,
  maxMarksData,
  annualPercent,
  finYearLabel,
  total,
  setLoader,
  finYear,
}) {
  const [criteriaResult, setCriteriaResult] = useState([]);

  useEffect(() => {
    const fetchCriteria = async () => {
      setLoader(true);
      try {
        const response = await authFetch(
          `${API_BASE_URL}/api/criteria-result?student=${student.admission}&type='annual'&finYear=${finYear}`,
        );
        const result = await response.json();
        setCriteriaResult(result.result);
      } catch (error) {
        console.error("Error fetching Criteria results:", error);
      } finally {
        setLoader(false);
      }
    };
    fetchCriteria();
  }, [student]);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <Button
          variant="success"
          className="mb-3"
          onClick={() =>
            ExportAnnualPDF({
              student,
              standardLabel,
              divisionLabel,
              marksData,
              maxMarksData,
              annualPercent,
              finYearLabel,
              criteriaResult,
            })
          }
        >
          Export PDF
        </Button>
      </div>
      <Table striped bordered hover id="marksTable">
        <thead>
          <tr>
            <th rowSpan={2} style={{ verticalAlign: "middle" }}>
              SUBJECT
            </th>
            <th>PERIODIC TESTS</th>
            <th>INTERNAL ASSESSMENT</th>
            <th>HALF YEARLY EXAM</th>
            <th>ANNUAL EXAM</th>
            <th>TOTAL</th>
            <th>GRADE</th>
          </tr>
          <tr>
            <th>{annualPercent.pt}</th>
            <th>{annualPercent.ia}</th>
            <th>{annualPercent.hy}</th>
            <th>{annualPercent.ae}</th>
            <th>100</th>
            <th>A1-E1</th>
          </tr>
        </thead>
        <tbody>
          {marksData.map((row, idx) => (
            <tr key={idx}>
              <td>{row.subjectName}</td>
              <td>{row.pt}</td>
              <td>{row.ia}</td>
              <td>{row.hy}</td>
              <td>{row.ae}</td>
              <td>{row.total}</td>
              <td>{row.grade}</td>
            </tr>
          ))}
          <tr>
            <td colSpan={5} className="text-end">
              Total
            </td>
            <td>{total}</td>
            <td></td>
          </tr>
          <tr>
            <td colSpan={5} className="text-end">
              Percentage
            </td>
            <td>{(total / marksData.length).toFixed(2)}%</td>

            <td></td>
          </tr>
        </tbody>
      </Table>
    </>
  );
}

export default Annual;
